/**
 * SY-02.1 age gate. With a birth year alone, a player turning 13 this year may
 * still be 12, so the check is conservative and matches the API
 * (nowYear - birthYear <= 13 => COPPA mode).
 */
export function isChild(birthYear: number, nowYear: number): boolean {
  return nowYear - birthYear <= 13;
}

export interface CapabilityInput {
  coppa: boolean;
  /** a parent verified the account (unlocks the store only) */
  parentVerified?: boolean;
  /** effective consent to personalised ads */
  personalizedConsent: boolean;
}

export interface Capabilities {
  personalizedAds: boolean;
  store: boolean;
  friendSearch: boolean;
}

/** COPPA mode: contextual ads only, no store without a parent, no friend search. */
export function capabilities(i: CapabilityInput): Capabilities {
  return {
    personalizedAds: !i.coppa && i.personalizedConsent,
    store: !i.coppa || i.parentVerified === true,
    friendSearch: !i.coppa,
  };
}
